<template>
  <section class="section--values">
    <div class="section__info">
      <h2 class="section__title dms700">
        Our <span class="underline">Values</span>
      </h2>
      <p class="section__description">
        These values form the foundation of who we are, guiding how we elevate
        professionals, empower businesses, <br> and fuel innovation without limits.
      </p>
    </div>

    <div class="values-container">
      <!-- First row -->
      <div class="value-card">
        <div class="icon-container">
          <img
            :src="require('@/assets/img/driving.svg')"
            alt="Trophy icon"
            class="value-icon"
          />
        </div>
        <div class="value-content">
          <h3 class="value-heading">
            <span class="colored-text">Driving</span> Success
          </h3>
          <p class="value-description">
            We focus on empowering our customers and our employees to achieve
            their goals through meaningful collaboration.
          </p>
        </div>
      </div>

      <div class="value-card">
        <div class="icon-container">
          <img
            :src="require('@/assets/img/innovation.svg')"
            alt="Innovation icon"
            class="value-icon"
          />
        </div>
        <div class="value-content">
          <h3 class="value-heading">
            <span class="colored-text">Innovation</span> at the Core
          </h3>
          <p class="value-description">
            Our solutions are designed to spark creativity, enable
            breakthroughs, and build a better future for businesses and
            communities.
          </p>
        </div>
      </div>

      <!-- Second row -->
      <div class="value-card">
        <div class="icon-container">
          <img
            :src="require('@/assets/img/growth.svg')"
            alt="Growth icon"
            class="value-icon"
          />
        </div>
        <div class="value-content">
          <h3 class="value-heading">
            <span class="colored-text">Growth</span> for All
          </h3>
          <p class="value-description">
            We enable sustainable growth for our clients while driving digital
            transformation projects in developing communities
          </p>
        </div>
      </div>

      <div class="value-card">
        <div class="icon-container">
          <img
            :src="require('@/assets/img/unlimited.svg')"
            alt="Unlimited possibilities icon"
            class="value-icon"
          />
        </div>
        <div class="value-content">
          <h3 class="value-heading">
            <span class="colored-text">Unlimited</span> Possibilities
          </h3>
          <p class="value-description">
            We are committed to unlocking potential, delivering exceptional
            results, and creating lasting impact without boundaries.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'GoalSection',
};
</script>

<style scoped>
.section--values {
  padding-block: 1rem;
  padding-inline: var(--about-page-gutter, clamp(1rem, 4vw, 2rem));
  background-color: var(--secondary-color-lightest);
  position: relative;
  overflow: hidden;
  width: 100%;
}

.section__info {
  margin-top: 4rem;
  text-align: left;
  max-width: var(--about-content-max, 1400px);
  margin-inline: auto;

  /* margin: 0 auto 3rem; */
}

.section__title {
  font-size: 2.5rem;
  padding-left: 0;
  color: var(--dark-color);
  position: relative;
  display: inline-block;
}

.underline {
  position: relative;
  display: inline-block;
}

.underline::after {
  content: '';
  position: absolute;
  left: 50%;
  bottom: -5px;
  width: 100%;
  height: 10px;
  background-image: url('@/assets/img/underline.svg'); /* Using alias */
  background-repeat: no-repeat;
  background-size: contain;
  transform: translateX(-50%);
}
/* .section__title::after {
  content: '';
  position: absolute;
  bottom: -0.5rem;
  left: 50%;
  transform: translateX(-50%);
  width: 80%;
  height: 4px;
  background-color: var(--accent-red);
  border-radius: 2px;
} */

.section__description {
  font-size: 16px;
  /* line-height: 1.6; */
  padding: 1.5rem 0 2rem;

  width: 100%;
  margin: 0 auto;
  color: var(--dark-color);
  margin-bottom: 2rem;
  /* text-align: left; */
  overflow-wrap: anywhere;
}

.values-container {
  display: grid;
  gap: 2rem;
  max-width: var(--about-content-max, 1400px);
  margin: 2rem 0;
  margin-inline: auto;
}

.value-card {
  display: grid;
  flex-direction: column;
  max-width: 100%;

  align-items: left;
  text-align: left;
  /* padding: 1.5rem; */
}

.icon-container {
  /* display: flex; */
  align-items: left;
  justify-content: left;
}

.value-icon {
  width: 40px;
  height: auto;
}

.value-content {
  width: 100%;
  text-align: left;
}

.value-heading {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  /* font-weight: 600; */
  color: var(--dark-color);
}

.colored-text {
  color: var(--primary-color);
}

.value-description {
  font-size: 1rem;
  line-height: 1.5;
  color: var(--dark-color);
}

/* Responsive styles */
@media (min-width: 768px) {
  .section--values {
    /* padding: 6rem 2rem; */
    padding-block: 10px;
    padding-inline: var(--about-page-gutter, clamp(1rem, 4vw, 2rem));
    /* margin: 10px; */
  }

  .values-container {
    grid-template-columns: repeat(2, 1fr);
    text-align: left;
    align-items: flex-start;
  }

  .value-card {
    flex-direction: row;
    text-align: left;
    align-items: flex-start;
  }

  .icon-container {
    margin-right: 1.5rem;
    margin-bottom: 0;
  }

  .value-content {
    text-align: left;
  }
}

@media (min-width: 992px) {
  .section__title {
    font-size: 3rem;
    padding-left: 0;
  }

  .value-card {
    padding: 2rem;
    text-align: left;
    align-items: flex-start;
  }

  .value-heading {
    font-size: 1.75rem;
  }

  .value-description {
    font-size: 1.1rem;
  }
}

@media (min-width: 1200px) {
  .value-heading {
    font-size: 2rem;
  }

  .value-card {
    padding: 2.5rem;
    text-align: left;
    align-items: flex-start;
  }
  .values-container {
    align-items: center;
    justify-content: center;
    display: grid;
    gap: 2rem;
    padding: 0;
    margin-block: 0;
  }
  .section__info {
    margin-top: 4rem;
    text-align: center;
    padding: 0;
    /* margin: 0 auto 3rem; */
  }
  .section__description {
    /* padding-left: 10%; */


    /* width: 80%; */
  }
}

@media (max-width: 960px) {
  .section--values {
    padding-inline: var(--about-mobile-section-gutter, calc(1rem + 12px));
  }
}

@media (max-width: 480px) {
  .section__title {
    font-size: 2rem;
  }

  .section__info {
    margin-top: 2rem;
  }

  .values-container {
    gap: 1.5rem;
  }
}
</style>
